import { render, staticRenderFns } from "./VideoHeatModule.vue?vue&type=template&id=dadf77e0&scoped=true"
import script from "./VideoHeatModule.vue?vue&type=script&lang=js"
export * from "./VideoHeatModule.vue?vue&type=script&lang=js"
import style0 from "./VideoHeatModule.vue?vue&type=style&index=0&id=dadf77e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dadf77e0",
  null
  
)

export default component.exports